/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description TimePicker
 */
import { TimePicker as AntdTimePicker } from 'antd';
import dayjs from 'dayjs';

export interface IProps {
	value: string | null;
	placeholder?: string;
	allowClear?: boolean | { clearIcon: React.ReactNode };
	format?: string;
	disabled?: boolean;
	suffixIcon?: React.ReactNode;
	onChange: (value: string | null) => void;
	use12Hours?: boolean;
}

/**
 * Time Picker
 * @param {IProps} props props
 * @returns {React.FC} TimePicker
 */
const TimePicker: React.FC<IProps> = ({
	value,
	onChange,
	placeholder,
	allowClear,
	disabled,
	format = 'HH:mm:ss',
	suffixIcon,
	use12Hours = false,
}) => {
	const parseTimeValue = (timeString: string | null) => {
		if (!timeString) {
			return null;
		}

		// "14:30:00" -> dayjs object with time
		// "14:30" -> dayjs object with time (add :00 seconds)
		const timeValue = timeString.includes(':') ? timeString : `${timeString}:00`;

		return dayjs(timeValue, format);
	};

	const formatTimeValue = (dayjsObj: dayjs.Dayjs | null) => {
		if (!dayjsObj) {
			return null;
		}
		return dayjsObj.format(format);
	};

	return (
		<AntdTimePicker
			format={format}
			style={{ width: '100%' }}
			value={parseTimeValue(value)}
			onChange={(time) => onChange(formatTimeValue(time))}
			placeholder={placeholder}
			allowClear={allowClear}
			disabled={disabled}
			suffixIcon={suffixIcon}
			use12Hours={use12Hours}
		/>
	);
};

export default TimePicker;
